import React, { useEffect, useState } from 'react'
import styled  from 'styled-components'
import { useNavigate,useLocation } from 'react-router-dom'
import { toast } from 'react-toastify';
import BackLink from '../../components/BackLink'
import { handleExchangeCard } from '../../apis';

export default function Cardsecret() {
   const {state} = useLocation()
   const [code,setCode] =  useState('')

   const exchangeCard = async (code) => {

    let res = await handleExchangeCard({number:code})
    //  console.log(res.data)
    if(res.data.code === 0){
        toast.success('兑换成功')
    }else{
        toast.error(res.data.message)
    }
   }
  
  return (
    <Block className='w-[1000px] sm:w-full px-[117px] sm:px-[15px]'> 
        <div className='mt-[40px]'>
            <BackLink  to={-1}>返回</BackLink> 
        </div>
       
            <Warpper className='w-[600px] sm:w-full py-[48px] px-[136px] sm:p-4'>
                <Title>兑换会员</Title>
                    <Input  className='w-[328px] sm:w-full' value={code}  onChange={ (e) => setCode(e.target.value) } placeholder='输入兑换卡密'   />
                    <Button  className={`w-[328px] sm:w-full ${code == '' ?  'bg-[#E5E5EA] text-[#C7C7CC]': 'bg-[#0057FF] active:bg-[#347DFF] text-white'} `} disabled={!code} onClick={ () => {
                        if( code === '' ) {
                            return false
                        }
                        exchangeCard(code);
                    }}>确认激活</Button>
                <a href="https://borderfree.app/pricing/" target="_blank" rel="noopener noreferrer">
                    <div className='flex items-center justify-center mt-4'>
                        <p className="text-sm text-[#1C58FD] mr-1.5">暂无会员？前往购买</p>
                        <svg t="1697523956894" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4004" width="20" height="20">
                            <path d="M512 960c-247.039484 0-448-200.960516-448-448S264.960516 64 512 64 960 264.960516 960 512 759.039484 960 512 960zM512 128c-211.744443 0-384 172.255557-384 384s172.255557 384 384 384 384-172.255557 384-384S723.744443 128 512 128z" fill="#1C58FD" p-id="4005"></path>
                            <path d="M732.959548 501.152426c-0.032684-0.127295-0.192662-0.25631-0.25631-0.383604-1.536138-3.615858-3.648542-7.071738-6.591802-10.047682-0.032684-0.032684-0.063647-0.032684-0.096331-0.063647-0.032684-0.032684-0.032684-0.063647-0.063647-0.096331l-158.911974-159.359226c-12.480043-12.480043-32.704421-12.576374-45.248112-0.063647-12.512727 12.480043-12.54369 32.735385-0.063647 45.248112l103.328907 103.616181L320 480.00258c-17.664722 0-31.99914 14.336138-31.99914 32.00086s14.336138 32.00086 31.99914 32.00086l306.752748 0-106.112189 104.959656c-12.576374 12.447359-12.672705 32.671738-0.25631 45.248112 6.239161 6.335493 14.496116 9.504099 22.751351 9.504099 8.12794 0 16.25588-3.103239 22.496761-9.247789l160.25545-158.495686C735.328262 526.592447 737.72794 512.767209 732.959548 501.152426z" fill="#1C58FD" p-id="4006"></path>
                        </svg>
                    </div>
                </a>
            </Warpper>
            
       
    </Block>
  )
}

const Block = styled.div`
    margin:0 auto;
    text-align:left;
`
const Warpper = styled.div`
    background: #FFFFFF;
    border-radius: 16px;
    margin: 0 auto;
    margin-bottom:56px;
    margin-top:48px;
`
const Title = styled.div`
    width: 96px;
    height: 28px;
    font-size: 24px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #1A1A1A;
    line-height: 28px;
`
const  Button = styled.button`
    height: 40px;
   
    border-radius: 4px;
    
    outline:none;
    border:none;
    cursor: pointer;
    display:block;
    margin:0 auto;
`
const Input = styled.input`
    height: 40px;
    background: #EFEFF4;
    border-radius: 4px;
    padding:10px;
    outline:none;
    border-color:transparent;
    margin:32px 0;
`